import {peakConfirm} from "../../../PeakDialog.js";
import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountListingIndexImport implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountListingIndexImportContainer";
    }
    render(){
        // console.log("listing index import");
        const formElement=$(".zidxAccountListingIndexImportContainer .zidxForm", this.zidx.peakidxShadowRoot)[0];
        if(!formElement){
            return;
        }
        formElement.setAttribute("data-event-bound", "1");
        formElement.addEventListener("submit", function(e:Event){
            if(formElement.getAttribute("data-peak-confirmed")){
                formElement.removeAttribute("data-peak-confirmed");
                return;
            }
            e.preventDefault();
            e.stopImmediatePropagation();
            peakConfirm("All files and fields for this index will be deleted if you proceed with import. Proceed?").then(function(ok){
                if(ok){
                    formElement.setAttribute("data-peak-confirmed", "1");
                    (formElement as HTMLFormElement).requestSubmit();
                }
            });
        });
    }
}